<template>
  <v-list-item @click="$emit('click')">
    <v-list-item-action class="mr-2">
      <StIcon
        :icon-name="icon"
      />
    </v-list-item-action>

    <v-list-item-content>
      <v-list-item-title>{{ text }}</v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
import StIcon from '@stilingue/st-icon/StIcon';

export default {
  name: 'StUserMenuListItem',
  components: {
    StIcon
  },
  props: {
    icon: {
      type: String,
      default: 'home'
    },
    text: {
      type: String,
      default: 'Item'
    }
  }
};
</script>

<style lang="scss" scoped>
  .v-list__tile__action {
    min-width: 36px;
  }

  .v-list-item__title {
    line-height: 1.4;
  }
</style>
